import { createFileRoute } from "@tanstack/react-router";
import { communitiesQuery } from "@/api/queries/communities";
import { feedInfiniteQuery } from "@/api/queries/feed";
import { productsQuery } from "@/api/queries/products";
import { suggestedCreatorsQuery } from "@/api/queries/creators";
import { studioStoresQuery } from "@/api/queries/discover-extra";
import { ExplorePage } from "@/pages/explore/ExplorePage";

export const Route = createFileRoute("/_app/explore")({
  loader: ({ context }) => {
    void Promise.all([
      context.queryClient.prefetchQuery(productsQuery({ sort: "popular", pageSize: 8 })),
      context.queryClient.prefetchQuery(suggestedCreatorsQuery()),
      context.queryClient.prefetchQuery(studioStoresQuery()),
      context.queryClient.prefetchQuery(communitiesQuery()),
      context.queryClient.prefetchInfiniteQuery(feedInfiniteQuery("trending")),
    ]);
  },
  component: ExplorePage,
});
